<template>
  <div class="app-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>升年级设置</span>
      </div>
      <div>系统会统一在每年9月1号进行升年级，此功能为机构需要提前升年级时使用，目前只支持在8月1号~8月31号操作提前升年级。</div>
      <div class="warning_text element_margin_top">此操作对机构所有学员生效，不可撤回，一年只可操作一次，请谨慎操作。</div>
      <div class="filter-form">
        <el-button style="padding: 12px 20px!important" type="primary" class="element_margin_top" @click="fnUpdate">提前升年级</el-button>

      </div>
      <div v-if="lastestOperate" class="element_margin_top">最近操作时间: {{ lastestOperate.create_time }}[{{ lastestOperate.batch }}] 操作人: {{ lastestOperate.editor_name }}</div>
    </el-card>
  </div>
</template>

<script>

export default {
  components: {

  },
  data() {
    return {
      lastestOperate: null
    }
  },
  created() {
    this.getLastest()
  },
  methods: {
    getLastest() {
      this.$http.getUpgradeList().then(res => {
        if (res.data && res.data.length > 0) {
          this.lastestOperate = res.data[0]
        }
      })
    },
    fnUpdate() {
      this.$prompt(
        '请输入『我确定要升年级』以确认升年级操作：',
        '危险操作确认(不可撤回)',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          // 把输入框放进 message 里
          inputValidator: value => {
            // value 可能是 undefined，先兜底
            const text = (value || '').trim()
            return text === '我确定要升年级' ? true : '文字必须与『我确定要升年级』完全一致'
          },
          // 让 Element 把输入框渲染出来
          showInput: true,
          inputPattern: /.+/, // 只要非空即可，真正校验交给 beforeClose
          inputErrorMessage: '请输入文字'
        }
      ).then(() => {
        // 用户已正确输入并点击确定，这里执行真正的升年级逻辑
        this.doUpgrade()
      }).catch(() => {
        /* 用户点了取消或关闭弹窗，什么都不做 */
      })
    },
    doUpgrade() {
      this.$http.setUpgrade().then((res) => {
        if (res.code == 777) {
          this.doUpgrade()
          return
        }
        if (res.code === 200) {
          this.$message.success('升年级操作成功')
          return
        }
      })
    }
  }
}
</script>

  <style scoped lang="scss">
  .element_margin_top {
    margin-top: 10px;
  }
.warning_text{
  color: #F56C6C;
}
  </style>

